/**
 * The assistant protocol, shared by apps/agent (producer), apps/server
 * (relay) and apps/web (consumer).
 *
 * The agent emits already-reduced events rather than raw SDK messages, so
 * neither the API nor the browser has to know anything about the Claude
 * Agent SDK, and an SDK upgrade cannot ripple outward.
 */
export const AGENT_EVENT_VERSION = 1;
/** Tool result bodies are capped before they reach the stream or the DB. */
export const TOOL_RESULT_MAX_BYTES = 8 * 1024;
/** Heartbeat cadence for the SSE relay. Keeps proxies from closing an idle stream. */
export const SSE_HEARTBEAT_MS = 15_000;
/** How long a disconnected run waits for the browser to come back. */
export const RUN_DISCONNECT_GRACE_MS = 60_000;
/** Cost is stored as integer micro-USD; float dollars accumulate error. */
export const microUsd = (usd) => Math.round(usd * 1_000_000);
export const formatUsd = (micro) => `$${(micro / 1_000_000).toFixed(2)}`;
/**
 * Longest prompt one turn accepts, in characters.
 *
 * Bounded rather than unbounded because the whole message is replayed into
 * every subsequent turn of the thread. Cost is not the reason: a run is
 * already capped by AGENT_MAX_BUDGET_USD, so an oversized prompt spends the
 * budget and stops rather than running away.
 *
 * Shared so the composer can refuse before the user loses their draft; the
 * api enforces the same number as the real boundary.
 */
export const MAX_CHAT_MESSAGE_CHARS = 100_000;
//# sourceMappingURL=agent.js.map